import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, ShieldCheckIcon, CurrencyDollarIcon } from '@heroicons/react/24/outline';

const StatsSection = () => {
  const stats = [
    {
      icon: ClockIcon,
      title: "Operating",
      value: "since 2018",
      description: "Proven track record"
    },
    {
      icon: ShieldCheckIcon,
      title: "Personalized",
      value: "client care 24/7",
      description: "Round-the-clock support"
    },
    {
      icon: CurrencyDollarIcon,
      title: "Assets under management",
      value: "$11+ billion",
      description: "Trusted by millions"
    }
  ];

    return (
    <section className="py-16 lg:py-24 bg-white overflow-hidden">
      <div className="section-container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ 
            duration: 1.2, 
            ease: [0.25, 0.46, 0.45, 0.94],
            delay: 0.2 
          }}
          viewport={{ once: true, margin: "-100px" }}
          className="text-center mb-12 lg:mb-16"
        >
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
                                className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4 font-heading"
          >
            Trusted by clients worldwide
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            viewport={{ once: true }}
            className="text-lg text-gray-600 max-w-2xl mx-auto"
          >
            Our commitment to excellence and security has made us a trusted partner in crypto wealth management.
          </motion.p>
        </motion.div>

         <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
           {stats.map((stat, index) => (
             <motion.div
               key={index}
               initial={{ opacity: 0, y: 40, scale: 0.95 }}
               whileInView={{ opacity: 1, y: 0, scale: 1 }}
               transition={{ 
                 duration: 1, 
                 ease: [0.25, 0.46, 0.45, 0.94],
                 delay: index * 0.15 
               }}
               viewport={{ once: true, margin: "-50px" }}
               whileHover={{ 
                 y: -8, 
                 scale: 1.02,
                 transition: { duration: 0.3, ease: "easeOut" }
               }}
               className="group"
             >
               <motion.div 
                 className="bg-white rounded-lg p-4 lg:p-5 border border-gray-200 shadow-sm hover:shadow-lg transition-all duration-500 ease-out"
                 whileHover={{ 
                   boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
                   borderColor: "#e5e7eb"
                 }}
               >
                 {/* Icon and Content Row */}
                 <div className="flex items-center space-x-3">
                   <motion.div 
                     className="w-8 h-8 lg:w-10 lg:h-10 bg-gray-100 rounded-lg flex items-center justify-center group-hover:bg-gray-200 transition-all duration-300 flex-shrink-0"
                     whileHover={{ 
                       scale: 1.1,
                       rotate: 5,
                       transition: { duration: 0.2 }
                     }}
                   >
                     <motion.div
                       initial={{ opacity: 0, scale: 0.5 }}
                       whileInView={{ opacity: 1, scale: 1 }}
                       transition={{ duration: 0.5, delay: index * 0.2 + 0.8 }}
                       viewport={{ once: true }}
                     >
                       <stat.icon className="w-4 h-4 lg:w-5 lg:h-5 text-gray-600" />
                     </motion.div>
                   </motion.div>
                   
                   <div className="flex-1 min-w-0">
                     <motion.h3 
                       initial={{ opacity: 0, x: -10 }}
                       whileInView={{ opacity: 1, x: 0 }}
                       transition={{ duration: 0.6, delay: index * 0.2 + 1 }}
                       viewport={{ once: true }}
                       className="text-xs lg:text-sm font-medium text-gray-600 uppercase tracking-wide mb-1"
                     >
                       {stat.title}
                     </motion.h3>
                     <motion.p 
                       initial={{ opacity: 0, x: -10 }}
                       whileInView={{ opacity: 1, x: 0 }}
                       transition={{ duration: 0.6, delay: index * 0.2 + 1.2 }}
                       viewport={{ once: true }}
                       className="text-lg lg:text-xl font-bold text-gray-900"
                     >
                       {stat.value}
                     </motion.p>
                   </div>
                 </div>
                 
                 <motion.p 
                   initial={{ opacity: 0, y: 10 }}
                   whileInView={{ opacity: 1, y: 0 }}
                   transition={{ duration: 0.5, delay: index * 0.2 + 1.4 }}
                   viewport={{ once: true }}
                   className="text-xs text-gray-500 mt-2 ml-11 lg:ml-12"
                 >
                   {stat.description}
                 </motion.p>
               </motion.div>
             </motion.div>
           ))}
         </div>
      </div>
    </section>
  );
};

export default StatsSection; 